(function () {
    var MontaChargeRequestCtrl = (function () {
        function MontaChargeRequestCtrl() {
            this.init.apply(this, arguments);
        }

        MontaChargeRequestCtrl.prototype = {
            init: function ($scope, $state, $stateParams, MKioskService, 
                $q, $loading, $message, $mdDialog, $translationService,
                ChargeRequestService, chargingPointId, userId, vehicleId, chargeSessionId, initAction) {

                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.MKioskService = MKioskService;
                this.$q = $q;
                this.$loading = $loading;
                this.$message = $message;
                this.$mdDialog = $mdDialog;
                this.$translationService = $translationService;

                this.chargeRequestService = ChargeRequestService,
                this.chargingPointId = chargingPointId;
                this.userId = userId,
                this.vehicleId = vehicleId;                

                this.initAction = initAction;


                var _this = this;
                this.currentState =  'connecting'; // connecting, connect_ok, connect_error, disconnecting, disconnect_ok, disconnect_error                

                if (this.initAction == 'disconnect') {
                    var montaRequest = {
                        "ChargingPointId": chargingPointId,
                        "UserId": userId,
                        "Id": chargeSessionId
                    }

                    this.currentState = 'disconnecting'
                    this.chargeRequestService.disconnect(montaRequest).then(function (result) {
                        _this.currentState = 'disconnect_ok';
                    }, function (error) {
                        _this.currentState = 'disconnect_error';                        

                        _this.errorMessage = error.data.message || error.data.code;

                        if (error.data.code && $translationService.existTranslation(error.data.code)) {
                            _this.errorMessage = $translationService.getTranslation(error.data.code);
                        }
                        
                    });

                } else {
                    var montaRequest = {
                        "ChargingPointId": chargingPointId,
                        "UserId": userId,
                        "VehicleId": vehicleId
                    }               

                    this.chargeRequestService.connect(montaRequest).then(function (result) {
                        _this.currentState = 'connect_ok';
                    }, function (error) {
                        _this.currentState = 'connect_error';

                        _this.errorMessage = error.data.message || error.data.code;

                        if (error.data.code && $translationService.existTranslation(error.data.code)) {
                            _this.errorMessage = $translationService.getTranslation(error.data.code);
                        }
                        
                    });

                }
            },
            onClose: function () {
                if (this.currentState.indexOf('error') >= 0 )  {
                    this.$mdDialog.cancel();
                } else if (this.currentState.indexOf('ok') >= 0) {
                    this.$mdDialog.hide(true);
                }                
            }
        };
        MontaChargeRequestCtrl.$inject = ['$scope', '$state', '$stateParams', 'MKioskService', '$q', '$Loading', '$message', '$mdDialog', '$translationService', 'ChargeRequestService', 'chargingPointId', 'userId', 'vehicleId', "chargeSessionId", 'initAction'];
        return MontaChargeRequestCtrl;
    }());
    angular.module('internal.chargingrequest').controller('MontaChargeRequestCtrl', MontaChargeRequestCtrl)
})();


